var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-container"},[_c('div',{staticClass:"input-loading"},[(_vm.hasIcon)?_c('span',{staticClass:"fa",class:_vm.icon}):_vm._e(),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }